document.addEventListener('formdata', (event) => {
  const discount = event.formData.get('discount');
  if (typeof discount === 'string' && discount.trim() === '') {
    event.formData.delete('discount');
  }
});

// Retire the previously public campaign once per browser.
(async () => {
  const marker = 'jr-autumn20-newsletter-only-20261018';
  try {
    if (localStorage.getItem(marker)) return;
    const explicit = new URLSearchParams(location.search).get('discount') || '';
    if (explicit.split(',').some(code => code.trim().toUpperCase() === 'AUTUMN20')) {
      localStorage.setItem(marker, '1');
      return;
    }
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(root + 'cart.js', { cache: 'no-store' });
    if (!response.ok) return;
    const cart = await response.json();
    const codes = new Set((cart.discount_codes || []).map(item => item.code));
    for (const application of cart.cart_level_discount_applications || []) {
      if (application.type === 'discount_code') codes.add(application.title);
    }
    for (const item of cart.items || []) {
      for (const allocation of item.line_level_discount_allocations || []) {
        const application = allocation.discount_application;
        if (application?.type === 'discount_code') codes.add(application.title);
      }
    }
    const stale = [...codes].some(code => code.toUpperCase() === 'AUTUMN20');
    if (!stale) { localStorage.setItem(marker, '1'); return; }
    const retained = [...codes].filter(code => code.toUpperCase() !== 'AUTUMN20');
    const updated = await fetch(root + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: retained.join(',') })
    });
    if (!updated.ok) return;
    localStorage.setItem(marker, '1');
    location.reload();
  } catch (error) { console.warn('Cart discount cleanup could not finish.'); }
})();
